<div
  class="imaginus-session-search"
  [class.imaginus-session-search--footer]="placement === 'footer'"
>
  <div class="input-group bg-dark-layer rounded-pill px-3 py-1 d-flex align-items-center imaginus-session-search__field">
    <svg cIcon name="cilZoom" size="sm" aria-hidden="true"></svg>
    <input
      #searchInput
      type="search"
      class="form-control bg-transparent border-0 shadow-none p-0 ms-2 imaginus-session-search__input"
      [placeholder]="'layout.imaginusSearch.placeholder' | translate"
      [(ngModel)]="query"
      (input)="onQueryInput()"
      (focus)="onFocus()"
      autocomplete="off"
      [attr.aria-label]="'layout.imaginusSearch.ariaLabel' | translate"
      aria-controls="imaginus-session-search-results"
      [attr.aria-expanded]="dropdownOpen"
    />
    <button
      *ngIf="query"
      type="button"
      class="imaginus-session-search__clear btn btn-link p-0 border-0"
      (click)="clearQuery()"
      [attr.aria-label]="'layout.imaginusSearch.clear' | translate"
    >
      <svg cIcon name="cilX" size="sm" aria-hidden="true"></svg>
    </button>
  </div>

  <div
    *ngIf="dropdownOpen"
    id="imaginus-session-search-results"
    class="imaginus-session-search__dropdown"
    role="listbox"
    [attr.aria-label]="'layout.imaginusSearch.resultsAria' | translate"
  >
    <p *ngIf="loading" class="imaginus-session-search__meta">{{ 'layout.imaginusSearch.searching' | translate }}</p>
    <p *ngIf="!loading && apiResults.length === 0" class="imaginus-session-search__meta">
      {{ 'layout.imaginusSearch.noResults' | translate }}
    </p>
    <button
      *ngFor="let hit of apiResults"
      type="button"
      class="imaginus-session-search__hit"
      role="option"
      (click)="openSession(hit)"
    >
      <span class="imaginus-session-search__hit-title">{{ sessionTitle(hit.name) }}</span>
      <span class="imaginus-session-search__hit-snippet" *ngIf="hit.snippet">{{ hit.snippet }}</span>
      <span class="imaginus-session-search__hit-tag" *ngIf="hit.match_type === 'title'">{{ 'layout.imaginusSearch.matchTitle' | translate }}</span>
    </button>
  </div>
</div>
